import React, { useState, useRef, useContext } from "react";
import { FiPlus } from "react-icons/fi";
import Fab from "@material-ui/core/Fab";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import mixpanel from "mixpanel-browser";

import { api } from "../../../Services/Api";
import { AnswersContext } from "./../index";
import CreateAnswer from "../../CreateAnswer";
import ListPrevAnswers from "./ListPrevAnswers";
import { Container, Center } from "./styles";

function AddAnswer({ onAdd }) {
  const { product } = useContext(AnswersContext);
  const isMobile = useMediaQuery("(max-width:769px)");

  const [openModalAdd, setOpenModalAdd] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [answersList, setAnswersList] = useState([]);

  const btnRef = useRef();

  const handleClick = (event) => {
    setOpenPopover(true);
  };

  const handleClose = (event) => {
    setOpenPopover(false);
  };

  function handleOpenModal() {
    setOpenModalAdd(true);
    handleClose();
  }

  async function handleDoneAdd(question) {
    try {
      const createdQuestion = await addNewQuestion(question);
      onAdd(createdQuestion);
      mixpanel.track("Add Question");
    } catch (error) {
    } finally {
      setOpenModalAdd(false);
    }
  }

  async function handleClone(question) {
    try {
      const createdQuestion = await cloneQuestion(question);
      onAdd(createdQuestion);
    } catch (error) {
    } finally {
      setOpenModalAdd(false);
    }
  }

  async function cloneQuestion(question) {
    const { data } = await api.post(`/menu/questions/${question._id}/clone`, {
      productId: product._id,
    });
    return data;
  }

  async function addNewQuestion(question) {
    const { data } = await api.post(`/menu/questions`, {
      productId: product._id,
      ...question,
    });
    return data;
  }

  React.useEffect(() => {
    api
      .get(`/menu/products/${product._id}/suggested-questions`)
      .then(({ data }) => setAnswersList(data))
      .catch((err) => console.log("Erro ao carregar sugestões"));
  }, []);

  return (
    <Container>
      <Popover
        open={openPopover}
        anchorEl={btnRef.current}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <ListPrevAnswers
          answersList={answersList}
          onClose={handleClose}
          onAdd={handleClone}
        />
        <Button
          onClick={handleOpenModal}
          color="primary"
          fullWidth
          variant="contained"
        >
          Novo
        </Button>
      </Popover>
      <Fab ref={btnRef} color="primary" onClick={handleClick}>
        <FiPlus style={{ fontSize: "30px" }} />
      </Fab>
      <Dialog
        fullScreen={true}
        open={openModalAdd}
      >
        <DialogContent>
          <CreateAnswer
            onDone={handleDoneAdd}
            onClose={() => setOpenModalAdd(false)}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
}

export default AddAnswer;
